import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import { Image } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FeaturedCollections = function FeaturedCollections(_ref) {
  var blocks = _ref.blocks,
      collectionId = _ref.collectionId;
  var nodes = blocks.edges.filter(function (_ref2) {
    var node = _ref2.node;
    return node.collection.id !== collectionId;
  }); // console.info('nodes', collectionId, blocks, nodes);

  return /*#__PURE__*/_jsx("div", {
    className: css.root,
    children: /*#__PURE__*/_jsxs("nav", {
      className: css.inner,
      children: [nodes.map(function (_ref3, idx) {
        var _ref4;

        var block = _ref3.node;
        return /*#__PURE__*/_jsxs("a", {
          className: cc([css.item, (_ref4 = {}, _defineProperty(_ref4, css.first, idx === 0), _defineProperty(_ref4, css.last, idx === nodes.length - 1), _ref4)]),
          href: block.collection.absoluteUrl,
          style: {
            color: block.titleColor
          },
          children: [/*#__PURE__*/_jsx("div", {
            className: css.image,
            children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({
              alt: block.collection.title
            }, block.image), {}, {
              sizes: [190]
            }))
          }), block.title]
        }, block.id);
      }), /*#__PURE__*/_jsx("div", {
        "aria-hidden": "true",
        className: css.ghost
      })]
    })
  });
};

FeaturedCollections.propTypes = {
  blocks: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape({
      node: PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        titleColor: PropTypes.string,
        collection: PropTypes.shape({
          id: PropTypes.string,
          absoluteUrl: PropTypes.string
        })
      })
    }))
  }),
  collectionId: PropTypes.string
};
export default /*#__PURE__*/memo(FeaturedCollections);